/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import React from "react"
import qs from "qs"
import LocaleContext from "./src/context/localeContext"
import PageContext from "./src/context/pageContext"
import PriceContextProvider from "./src/context/priceContext"
import "react-perfect-scrollbar/dist/css/styles.css"

export const wrapPageElement = props => (
  <LocaleContext.Provider value={props.props.pageContext.locale || "en"}>
    <PriceContextProvider>
      <PageContext.Provider
        value={{
          isSimple: props.props.pageContext.simple,
        }}
      >
        {props.element}
      </PageContext.Provider>
    </PriceContextProvider>
  </LocaleContext.Provider>
)

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true })

  if (queryParams?.zone) {
    return false
  }

  return true
}
